;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');

	Router.offSeason = Marionette.AppRouter.extend({
		permissions: {
			offSeason: {
				type: 6,
				redirect_to: '#'
			},

		},
		appRoutes:{
			'off-season': 'offSeason',
		}
	});

}(window, APP, Backbone, Marionette, $, _));